<section [innerHTML]="content | safeHtml">

</section>
